import styled from "styled-components";

export const ToastStyles = styled.div`
    * {
        font-family: Inter, sans-serif;
    }
    .notifications {
        z-index: 1000000;
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);

        .collapsible {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
            h5 {
                filter: invert(1);
            }
            button {
                font-size: 12px;
                line-height: 1;
                margin-right: 8px;
                padding: 14px 12px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 16px;
                cursor: pointer;
                pointer-events: auto;
                user-select: none;
                color: var(--color-accent);
                background: var(--color-secondary-dark);
            }

            button:hover {
                //background: rgb(251, 251, 254);
                //color: rgb(31, 31, 31);

            }
        }

        .notificationWrapper {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            max-height: 400px;

            &::-webkit-scrollbar {
                width: 0;
                height: 0;
            }

            scrollbar-width: none;

            #toast-interactive {
                position: relative;
                min-height: 75px;
                max-height: 120px;
                height: max-content;
                //overflow-y: auto;
                background-color: var(--color-secondary);
                border: 1px solid color-mix(in srgb, var(--color-border) 5%, transparent);
                max-width: 24rem;
                width: 100vw;
                padding: 1rem;
                color: black;
                user-select: none;
                cursor: pointer;
                box-shadow: var(--shadow-sm);

                > div {
                    .notification-icon {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                        width: 2rem;
                        height: 2rem;
                        background-color: var(--color-primary);
                        padding: 2px;
                        position: sticky;
                        top: 0;
                        border-radius: 8px;

                        svg {
                            width: 1em;
                            font-size: 12px;
                        }
                    }

                    .text-content {
                        margin-inline-start: 0.5rem;
                    }
                }

                button {
                    //background: rgba(220, 224, 231, 0.3);
                    background: var(--color-secondary-dark) !important;
                    border: 1px solid #d0d5dd;
                }
            }
        }
    }

    ${({theme}: { theme: any }) => theme.breakpoints.down("md")} {
        .notifications {
            .collapsible {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 1rem;
                

                button {
                    font-size: 12px;
                }

                button:hover {

                }
            }

            .notificationWrapper {

                #toast-interactive {
                    position: relative;
                    height: auto;
                    width: calc(100vw - 20px);
                    max-width: 300px;
                    padding: 16px;
                    --color-accent: black;
                    user-select: none;
                    cursor: pointer;
                    backdrop-filter: none;

                    > div {
                        .notification-icon {
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            flex-shrink: 0;
                            width: 2rem;
                            height: 2rem;
                            padding: 2px;
                            border-radius: 8px;

                            svg {
                                width: 1em;
                                font-size: 12px;
                            }
                        }

                        .text-content {
                            margin-inline-start: 0.75rem;
                            font-size: 13px;
                            display: flex;
                            flex-direction: column;
                            gap: 2px;

                            h6, p {
                                color: black;
                                line-height: normal;
                            }

                        }
                    }

                    button {
                        background: rgba(220, 224, 231, 0.3);
                        border: 1px solid #d0d5dd;
                    }
                }
            }

        }
    }
    ${({ theme }: { theme: any }) => theme.breakpoints.down("sm")} {
        .notifications {
            top: 8px;
            width: calc(100vw - 16px);

            .toast {
                padding: 8px 10px;
            }
        }
    }
`